import { render, staticRenderFns } from "./45.vue?vue&type=template&id=64168232&scoped=true&"
import script from "./45.vue?vue&type=script&lang=js&"
export * from "./45.vue?vue&type=script&lang=js&"
import style0 from "./45.vue?vue&type=style&index=0&id=64168232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64168232",
  null
  
)

export default component.exports